<template>
  <div>
    <Breadcrumbs :items="items" />
    <v-dialog v-model="selectStockDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("CRUD.chooseInfo", [$t("Stock.ObjectName")]) }}
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 py-8 text-center subtitle-1">
          <SearcherStock
            v-model="selectStock"
            no-label
            :errorMessages="selectStockErrors"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-sheet class="transparent-background-color pa-4">
      <div id="pick-confirm-top">
        <v-card-title class="mx-3">
          <span class="danger--text pr-2">{{
            selectStock ? selectStock.Description : ""
          }}</span>

          {{ $t("StockOrderOUT.PackConfirmFields.title") }}
          <v-btn
            v-if="!packConfirming"
            dark
            text
            color="action"
            class="mb-n2"
            @click.stop="selectStockDialog = true"
          >
            {{ $t("CRUD.rechooseInfo", [$t("Stock.ObjectName")]) }}
          </v-btn>
          <v-spacer />
          <v-sheet
            v-if="packConfirming"
            class="pt-1 transparent-background-color d-inline-block"
          >
            <v-btn
              v-if="stock.pack_setting"
              small
              dark
              color="print"
              class="px-2 me-2 mb-1"
              @click.stop="addPackageBarcode()"
            >
              <v-icon x-small class="pe-1">fa-print</v-icon>
              {{ $t("StockOrderOUT.actions.packageBarcodePrint") }}
            </v-btn>
            <v-btn
              small
              dark
              color="action"
              class="px-2 me-2 mb-1"
              @click.stop="submitPackConfirm()"
            >
              <v-icon x-small class="pe-1">fa-check</v-icon>
              {{ $t("Wave.actions.pickingFinish") }}
            </v-btn>
            <v-btn
              small
              dark
              color="print"
              class="px-2 me-2 mb-1"
              @click.stop=""
            >
              <v-icon x-small class="pe-1">fa-print</v-icon>
              {{ $t("StockOrderOUT.actions.expressSheetPrint") }}
            </v-btn>
          </v-sheet>
        </v-card-title>
        <v-progress-linear></v-progress-linear>
        <!-- 选择出库单 -->
        <v-card-text v-if="!packConfirming">
          <v-container>
            <v-row align="center">
              <v-col md="7">
                <v-text-field
                  ref="stock_out_code"
                  v-model="stock_out_code"
                  :label="$t('StockOrderOUT.PackConfirmFields.bar_code')"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <!-- 确认出库单条码框 -->
        <v-card-text v-if="packConfirming">
          <v-container>
            <v-row align="center">
              <v-col md="7">
                <v-text-field
                  ref="barcode_input"
                  v-model="barcode_input_value"
                  :label="barcode_input_lable"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <!-- 包装袋周转筐table -->
            <v-row>
              <h1
                v-if="stock.container_setting && !stock.pack_setting"
                style="display: inline-block"
              >
                {{
                  $t("StockOrderOUT.PackConfirmFields.scan_container_barcode") +
                  $t("Global.colon")
                }}
                <span class="danger--text blod">
                  {{ scan_barcode_info.scan_container_barcode }}
                </span>
              </h1>
              <v-data-table
                v-if="stock.pack_setting"
                :headers="packageHeaders"
                :items="packageBarcodes"
                disable-sort
                disable-pagination
                hide-default-footer
                class="elevation-0 px-6"
                style="width: 500px"
                fixed-header
                height="260px"
              >
                <template
                  v-if="stock.container_setting"
                  v-slot:item.container_barcode="{ item }"
                >
                  <v-btn
                    v-if="!item.container_barcode"
                    dark
                    text
                    color="action"
                    class="mb-0"
                    @click.stop="bindingContainer(item)"
                  >
                    {{ $t("StockOrderOUT.actions.binding") }}
                  </v-btn>
                  <v-btn
                    v-else
                    dark
                    text
                    color="action"
                    class="mb-0"
                    @click.stop="
                      editBindingContainerAlert = true;
                      editBindingContainerMsg = $t(
                        'StockOrderOUT.Messages.edit_binding_container_msg',
                        [item.package_barcode]
                      );
                      editPackageInfo = item;
                    "
                  >
                    {{ item.container_barcode }}
                  </v-btn>
                </template>
                <template v-slot:item.actions>
                  <v-btn dark text color="action" class="mb-0" @click.stop="">
                    {{ $t("StockOrderOUT.actions.packageBarcodeReprint") }}
                  </v-btn>
                </template>
              </v-data-table>
            </v-row>
            <!-- 扫描确认详情table -->
            <ValidationObserver ref="observer">
              <v-row style="margin-top: 50px">
                <v-col cols="4" class="font-weight-bold text-center">
                  <h2 style="display: inline-block">
                    {{
                      $t("StockOrderOUT.PackConfirmFields.wait_pack_confirm") +
                      $t("Global.colon")
                    }}
                  </h2>
                  <v-data-table
                    :headers="headers"
                    :items="unConfirmDetails"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.confirm_stock_num="{ item }">
                      <span v-if="$i18n.locale == 'zhHans'">
                        {{ item.confirm_stock_num }}
                      </span>
                      <span v-else>
                        <span class="text-no-wrap caption font-weight-bold">
                          {{ item.confirm_num | formatTwoDot }}
                        </span>
                        <br />
                        <span
                          class="text-no-wrap caption secondary--text"
                          :class="
                            $vuetify.theme.dark
                              ? 'text--lighten-1'
                              : 'text--darken-1'
                          "
                        >
                          {{ item.unit }}
                        </span>
                      </span>
                    </template>
                    <template v-slot:item.pack_confirm_num="props">
                      <v-edit-dialog
                        :return-value="props.item.pack_confirm_num"
                        large
                        persistent
                        :cancel-text="$t('CRUD.abandon')"
                        :save-text="$t('CRUD.confirm')"
                        @save="updatePackConfirmNum(props.item, 1)"
                        @cancel="cancelEditPackConfirmNum(props.item)"
                        >{{ props.item.pack_confirm_num }}
                        <template v-slot:input>
                          <ValidationProvider
                            v-slot="{ errors }"
                            :rules="{
                              max_value: { max: props.item.confirm_num },
                            }"
                          >
                            <NumberInput
                              v-model="props.item.pack_confirm_num_input"
                              :error-messages="errors"
                              dense
                              autofocus
                              counter
                            >
                            </NumberInput>
                          </ValidationProvider>
                        </template>
                      </v-edit-dialog>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="4" class="font-weight-bold text-center">
                  <h2 style="display: inline-block">
                    {{
                      $t("StockOrderOUT.PackConfirmFields.pack_confirming") +
                      $t("Global.colon")
                    }}
                  </h2>
                  <v-data-table
                    v-if="stock.pack_setting || stock.container_setting"
                    :headers="groupHeaders"
                    :items="confirmingDetails"
                    disable-pagination
                    hide-default-footer
                    :group-by="stock.pack_setting ? 'package_barcode' : ''"
                  >
                    <template v-slot:group.header="{ group }">
                      {{ group }}
                    </template>

                    <template v-slot:item.confirm_stock_num="{ item }">
                      <span v-if="$i18n.locale == 'zhHans'">
                        {{ item.confirm_stock_num }}
                      </span>
                      <span v-else>
                        <span class="text-no-wrap caption font-weight-bold">
                          {{ item.confirm_num | formatTwoDot }}
                        </span>
                        <br />
                        <span
                          class="text-no-wrap caption secondary--text"
                          :class="
                            $vuetify.theme.dark
                              ? 'text--lighten-1'
                              : 'text--darken-1'
                          "
                        >
                          {{ item.unit }}
                        </span>
                      </span>
                    </template>
                    <template v-slot:item.pack_confirm_num="props">
                      <v-edit-dialog
                        :return-value="props.item.pack_confirm_num"
                        large
                        persistent
                        :cancel-text="$t('CRUD.abandon')"
                        :save-text="$t('CRUD.confirm')"
                        @save="updatePackConfirmNum(props.item, 2)"
                        @cancel="cancelEditPackConfirmNum(props.item)"
                        >{{ props.item.pack_confirm_num }}
                        <template v-slot:input>
                          <ValidationProvider
                            v-slot="{ errors }"
                            :rules="{
                              max_value: { max: props.item.confirm_num },
                            }"
                          >
                            <NumberInput
                              v-model="props.item.pack_confirm_num_input"
                              :error-messages="errors"
                              dense
                              autofocus
                              counter
                            >
                            </NumberInput>
                          </ValidationProvider>
                        </template>
                      </v-edit-dialog>
                    </template>
                  </v-data-table>
                  <v-data-table
                    v-else
                    :headers="headers"
                    :items="confirmingDetails"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.confirm_stock_num="{ item }">
                      <span v-if="$i18n.locale == 'zhHans'">
                        {{ item.confirm_stock_num }}
                      </span>
                      <span v-else>
                        <span class="text-no-wrap caption font-weight-bold">
                          {{ item.confirm_num | formatTwoDot }}
                        </span>
                        <br />
                        <span
                          class="text-no-wrap caption secondary--text"
                          :class="
                            $vuetify.theme.dark
                              ? 'text--lighten-1'
                              : 'text--darken-1'
                          "
                        >
                          {{ item.unit }}
                        </span>
                      </span>
                    </template>
                    <template v-slot:item.pack_confirm_num="props">
                      <v-edit-dialog
                        :return-value="props.item.pack_confirm_num"
                        large
                        persistent
                        :cancel-text="$t('CRUD.abandon')"
                        :save-text="$t('CRUD.confirm')"
                        @save="updatePackConfirmNum(props.item, 2)"
                        @cancel="cancelEditPackConfirmNum(props.item)"
                        >{{ props.item.pack_confirm_num }}
                        <template v-slot:input>
                          <ValidationProvider
                            v-slot="{ errors }"
                            :rules="{
                              max_value: { max: props.item.confirm_num },
                            }"
                          >
                            <NumberInput
                              v-model="props.item.pack_confirm_num_input"
                              :error-messages="errors"
                              dense
                              autofocus
                              counter
                            >
                            </NumberInput>
                          </ValidationProvider>
                        </template>
                      </v-edit-dialog>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="4" class="font-weight-bold text-center">
                  <h2 style="display: inline-block">
                    {{
                      $t("StockOrderOUT.PackConfirmFields.pack_confirmed") +
                      $t("Global.colon")
                    }}
                  </h2>
                  <v-data-table
                    v-if="stock.pack_setting || stock.container_setting"
                    :headers="groupHeaders"
                    :items="confirmedDetails"
                    disable-pagination
                    hide-default-footer
                    :group-by="stock.pack_setting ? 'package_barcode' : ''"
                  >
                    <template v-slot:group.header="{ group }">
                      {{ group }}
                    </template>
                    <template v-slot:item.confirm_stock_num="{ item }">
                      <span v-if="$i18n.locale == 'zhHans'">
                        {{ item.confirm_stock_num }}
                      </span>
                      <span v-else>
                        <span class="text-no-wrap caption font-weight-bold">
                          {{ item.confirm_num | formatTwoDot }}
                        </span>
                        <br />
                        <span
                          class="text-no-wrap caption secondary--text"
                          :class="
                            $vuetify.theme.dark
                              ? 'text--lighten-1'
                              : 'text--darken-1'
                          "
                        >
                          {{ item.unit }}
                        </span>
                      </span>
                    </template>
                    <template v-slot:item.pack_confirm_num="props">
                      <v-edit-dialog
                        :return-value="props.item.pack_confirm_num"
                        large
                        persistent
                        :cancel-text="$t('CRUD.abandon')"
                        :save-text="$t('CRUD.confirm')"
                        @save="updatePackConfirmNum(props.item, 3)"
                        @cancel="cancelEditPackConfirmNum(props.item)"
                        >{{ props.item.pack_confirm_num }}
                        <template v-slot:input>
                          <ValidationProvider
                            v-slot="{ errors }"
                            :rules="{
                              max_value: { max: props.item.confirm_num },
                            }"
                          >
                            <NumberInput
                              v-model="props.item.pack_confirm_num_input"
                              :error-messages="errors"
                              dense
                              autofocus
                              counter
                            >
                            </NumberInput>
                          </ValidationProvider>
                        </template>
                      </v-edit-dialog>
                    </template>
                  </v-data-table>
                  <v-data-table
                    v-else
                    :headers="headers"
                    :items="confirmedDetails"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.pack_confirm_num="props">
                      <v-edit-dialog
                        :return-value="props.item.pack_confirm_num"
                        large
                        persistent
                        :cancel-text="$t('CRUD.abandon')"
                        :save-text="$t('CRUD.confirm')"
                        @save="updatePackConfirmNum(props.item, 3)"
                        @cancel="cancelEditPackConfirmNum(props.item)"
                        >{{ props.item.pack_confirm_num }}
                        <template v-slot:input>
                          <ValidationProvider
                            v-slot="{ errors }"
                            :rules="{
                              max_value: { max: props.item.confirm_num },
                            }"
                          >
                            <NumberInput
                              v-model="props.item.pack_confirm_num_input"
                              :error-messages="errors"
                              dense
                              autofocus
                              counter
                            >
                            </NumberInput>
                          </ValidationProvider>
                        </template>
                      </v-edit-dialog>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </div>
    </v-sheet>
    <DialogAlert v-model="dialogAlert" :message="dialogAlertMsg" />
    <DialogAlert
      v-model="editBindingContainerAlert"
      :message="editBindingContainerMsg"
      useConfirm
      @confirm="editBindingContainer()"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherStock from "@/components/plugins/SearcherStock";
import StockOuts from "@/api/stock_outs";
import Containers from "@/api/containers";
import Stocks from "@/api/stocks";
import DialogAlert from "@/components/plugins/DialogAlert";
import NumberInput from "@/components/plugins/NumberInput";
import snackbar from "@/plugins/snackbar";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    Breadcrumbs,
    SearcherStock,
    DialogAlert,
    NumberInput,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: this.productionStockOUTFlg
            ? i18n.t("Nav.productionManagement")
            : this.orderStockOUTFlg
            ? i18n.t("Nav.orderManagement")
            : i18n.t("Nav.stockManagement"),
          disabled: false,
          replace: true,
          href: this.productionStockOUTFlg
            ? "/production-plans"
            : this.orderStockOUTFlg
            ? "/orders"
            : "/stocks",
        },
        {
          text: this.productionStockOUTFlg
            ? i18n.t("Nav.productionStockOUT")
            : this.orderStockOUTFlg
            ? i18n.t("Nav.ordersStockOrdersOut")
            : i18n.t("Nav.stockOrdersOut"),
          disabled: false,
          href: this.productionStockOUTFlg
            ? "/production-stock-out"
            : this.orderStockOUTFlg
            ? "/order-stock-out"
            : "/stock-orders-out",
        },
        {
          text: i18n.t("Nav.stockOutPackConfirm"),
          disabled: true,
          href: this.productionStockOUTFlg
            ? "/production-stock-out/stock-pack-confirm"
            : this.orderStockOUTFlg
            ? "/order-stock-out/stock-pack-confirm"
            : "/stock-orders-out/stock-pack-confirm",
        },
      ];
    },
    headers() {
      return [
        {
          text: i18n.t("StockOrderOUT.PackConfirmFields.material_name"),
          align: "start",
          sortable: false,
          value: "material_description",
        },
        {
          text: i18n.t("StockOrderOUT.PackConfirmFields.stock_out_num"),
          align: "start",
          sortable: false,
          value: "confirm_stock_num",
        },
        {
          text: i18n.t("StockOrderOUT.PackConfirmFields.confirmed_num"),
          align: "start",
          sortable: false,
          value: "pack_confirm_num",
        },
      ];
    },
    groupHeaders() {
      var headers = [
        {
          text: i18n.t("StockOrderOUT.PackConfirmFields.material_name"),
          align: "start",
          sortable: false,
          value: "material_description",
        },
        {
          text: i18n.t("StockOrderOUT.PackConfirmFields.stock_out_num"),
          align: "start",
          sortable: false,
          value: "confirm_stock_num",
        },
        {
          text: i18n.t("StockOrderOUT.PackConfirmFields.confirmed_num"),
          align: "start",
          sortable: false,
          value: "pack_confirm_num",
        },
      ];

      if (this.stock.pack_setting) {
        headers.splice(0, 0, {
          text: i18n.t("StockOrderOUT.PackConfirmFields.package_barcode"),
          align: "start",
          sortable: false,
          value: "package_barcode",
        });
      }

      return headers;
    },
    packageHeaders() {
      var headers = [
        {
          text: i18n.t("StockOrderOUT.PackConfirmFields.package_barcode"),
          align: "start",
          value: "package_barcode",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "center",
          value: "actions",
        },
      ];
      if (this.stock.pack_setting && this.stock.container_setting) {
        headers.splice(1, 0, {
          text: i18n.t("StockOrderOUT.PackConfirmFields.container"),
          value: "container_barcode",
          hidden: true,
          align: "center",
        });
      }
      return headers;
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    productionStockOUTFlg: false,
    orderStockOUTFlg: false,
    selectStockDialog: false,
    packConfirming: false,
    selectStock: null,
    selectStockErrors: [],
    stock: {},
    monitorTime: "",
    stock_out_code: null,
    dialogAlert: false,
    dialogAlertMsg: null,
    editBindingContainerAlert: false,
    editBindingContainerMsg: null,
    editPackageInfo: null,
    barcode_input_lable: "",
    barcode_input_value: null,
    stock_order_code: null,
    scan_barcode_info: [],
    material_bar_code: null,
    packageBarcodes: [],
    confirmingPackageInfo: [],
    confirmedPackageInfo: [],
    stockOutDetails: [],
    unConfirmDetails: [],
    confirmingDetails: [],
    confirmedDetails: [],
  }),

  methods: {
    bindingContainer(packageInfo) {
      this.scan_barcode_info.scan_package_barcode = packageInfo.package_barcode;
      this.barcode_input_lable = i18n.t(
        "StockOrderOUT.PackConfirmFields.scan_barcode",
        [""]
      );
      this.$nextTick(() => {
        this.$refs.barcode_input.focus();
      });
    },

    editBindingContainer() {
      this.scan_barcode_info.scan_package_barcode =
        this.editPackageInfo.package_barcode;
      this.scan_barcode_info.scan_container_barcode = "";
      this.barcode_input_lable = i18n.t(
        "StockOrderOUT.PackConfirmFields.scan_barcode",
        [i18n.t("StockOrderOUT.PackConfirmFields.container")]
      );
      this.$nextTick(() => {
        this.$refs.barcode_input.focus();
      });
    },

    updatePackConfirmNum(item_detail, location) {
      this.$refs.observer.validate().then(
        function (result) {
          //未确认
          var unConfirmDetail = this.unConfirmDetails.find(
            (detail) => detail.material_id == item_detail.material_id
          );

          if (result) {
            //根据包装码和周转筐的设置判断商品确认量是否可直接手动编辑
            var isEdit = false;
            if (this.stock.pack_setting && this.stock.container_setting) {
              //包装码和周转筐
              if (
                this.scan_barcode_info &&
                this.scan_barcode_info.scan_package_barcode &&
                this.scan_barcode_info.scan_container_barcode
              ) {
                isEdit = true;
              }
            } else if (this.stock.pack_setting) {
              //包装码
              if (
                this.scan_barcode_info &&
                this.scan_barcode_info.scan_package_barcode
              ) {
                isEdit = true;
              }
            } else if (this.stock.container_setting) {
              //周转筐
              if (
                this.scan_barcode_info &&
                this.scan_barcode_info.scan_container_barcode
              ) {
                isEdit = true;
              }
            } else {
              isEdit = true;
            }

            if (isEdit) {
              if (item_detail.pack_confirm_num_input > 0 && location == 1) {
                item_detail.pack_confirm_num =
                  item_detail.pack_confirm_num_input;
                if (this.stock.pack_setting && !item_detail.package_barcode) {
                  item_detail.package_barcode =
                    this.scan_barcode_info.scan_package_barcode;
                  //判断当前扫描的包装码是否绑定了周转筐
                  if (this.scan_barcode_info.scan_container_barcode) {
                    item_detail.container_barcode =
                      this.scan_barcode_info.scan_container_barcode;
                  }
                }
                //判断，更改确认位置
                var unConfirmFind = this.unConfirmDetails.findIndex(
                  (stock_out_detail) =>
                    stock_out_detail.material_id == item_detail.material_id
                );
                if (unConfirmFind > -1) {
                  if (
                    item_detail.pack_confirm_num_input < item_detail.confirm_num
                  ) {
                    item_detail.package_barcode =
                      this.scan_barcode_info.scan_package_barcode;
                    //是否开启了周转筐设置
                    if (this.stock.container_setting) {
                      item_detail.container_barcode =
                        this.scan_barcode_info.scan_container_barcode;
                    }
                    this.confirmingDetails.push(item_detail);
                    this.unConfirmDetails.splice(
                      this.unConfirmDetails.findIndex(
                        (stock_out_detail) =>
                          stock_out_detail.material_id ==
                          item_detail.material_id
                      ),
                      1
                    );
                  } else if (
                    item_detail.pack_confirm_num_input ==
                    item_detail.confirm_num
                  ) {
                    item_detail.package_barcode =
                      this.scan_barcode_info.scan_package_barcode;
                    //是否开启了周转筐设置
                    if (this.stock.container_setting) {
                      item_detail.container_barcode =
                        this.scan_barcode_info.scan_container_barcode;
                    }
                    this.confirmedDetails.push(item_detail);
                    this.unConfirmDetails.splice(
                      this.unConfirmDetails.findIndex(
                        (stock_out_detail) =>
                          stock_out_detail.material_id ==
                          item_detail.material_id
                      ),
                      1
                    );
                  }
                }
              } else if (location == 2) {
                item_detail.pack_confirm_num =
                  item_detail.pack_confirm_num_input;
                //确认量改为0
                var confirmingArr = this.confirmingDetails.filter(
                  (stock_out_detail) =>
                    stock_out_detail.material_id == item_detail.material_id
                );

                if (confirmingArr) {
                  let pack_confirm_num_count = 0;
                  confirmingArr.forEach((confirming) => {
                    pack_confirm_num_count += Number(
                      confirming.pack_confirm_num
                    );
                  });

                  if (pack_confirm_num_count == item_detail.confirm_num) {
                    confirmingArr.forEach((confirming) => {
                      this.confirmedDetails.push(confirming);
                      this.confirmingDetails.splice(
                        this.confirmingDetails.findIndex(
                          (stock_out_detail) =>
                            stock_out_detail.material_id ==
                              confirming.material_id &&
                            stock_out_detail.package_barcode ==
                              confirming.package_barcode &&
                            stock_out_detail.container_barcode ==
                              confirming.container_barcode
                        ),
                        1
                      );
                    });
                  } else if (pack_confirm_num_count == 0) {
                    //初始化所绑定的包装码和周转筐
                    item_detail.package_barcode = "";
                    item_detail.container_barcode = "";
                    this.unConfirmDetails.push(item_detail);
                    confirmingArr.forEach((confirming) => {
                      this.confirmingDetails.splice(
                        this.confirmingDetails.findIndex(
                          (stock_out_detail) =>
                            stock_out_detail.material_id ==
                              confirming.material_id &&
                            stock_out_detail.package_barcode ==
                              confirming.package_barcode &&
                            stock_out_detail.container_barcode ==
                              confirming.container_barcode
                        ),
                        1
                      );
                    });
                  } else if (pack_confirm_num_count > item_detail.confirm_num) {
                    this.$snackbar.error(
                      i18n.t("StockOrderOUT.Messages.edit_pack_confirm_num_max")
                    );
                  }
                }
              } else if (location == 3) {
                item_detail.pack_confirm_num =
                  item_detail.pack_confirm_num_input;
                //获取当前确认商品的所有确认信息
                var confirmedArr = this.confirmedDetails.filter(
                  (stock_out_detail) =>
                    stock_out_detail.material_id == item_detail.material_id
                );

                if (confirmedArr) {
                  let pack_confirm_num_count = 0;
                  confirmedArr.forEach((confirmed) => {
                    pack_confirm_num_count += Number(
                      confirmed.pack_confirm_num
                    );
                  });

                  if (pack_confirm_num_count == 0) {
                    //初始化所绑定的包装码和周转筐
                    item_detail.package_barcode = "";
                    item_detail.container_barcode = "";

                    this.unConfirmDetails.push(item_detail);

                    confirmedArr.forEach((confirmed) => {
                      this.confirmedDetails.splice(
                        this.confirmedDetails.findIndex(
                          (stock_out_detail) =>
                            stock_out_detail.material_id ==
                            confirmed.material_id
                        ),
                        1
                      );
                    });
                  } else if (
                    pack_confirm_num_count > 0 &&
                    pack_confirm_num_count < item_detail.confirm_num
                  ) {
                    confirmedArr.forEach((confirmed) => {
                      if (confirmed.pack_confirm_num > 0) {
                        this.confirmingDetails.push(confirmed);
                      }
                      this.confirmedDetails.splice(
                        this.confirmedDetails.findIndex(
                          (stock_out_detail) =>
                            stock_out_detail.material_id ==
                              confirmed.material_id &&
                            stock_out_detail.package_barcode ==
                              confirmed.package_barcode &&
                            stock_out_detail.container_barcode ==
                              confirmed.container_barcode
                        ),
                        1
                      );
                    });
                  } else if (pack_confirm_num_count > item_detail.confirm_num) {
                    let count = 0;
                    confirmedArr.forEach((confirmed) => {
                      if (
                        confirmed.material_id == item_detail.material_id &&
                        confirmed.package_barcode !=
                          item_detail.package_barcode &&
                        confirmed.container_barcode !=
                          item_detail.container_barcode
                      ) {
                        count += confirmed.pack_confirm_num;
                      }
                    });
                    item_detail.pack_confirm_num =
                      item_detail.confirm_num - count;
                    this.$snackbar.error(
                      i18n.t("StockOrderOUT.Messages.edit_pack_confirm_num_max")
                    );
                  }
                }
              } else {
                item_detail.pack_confirm_num_input =
                  item_detail.pack_confirm_num;
                this.$snackbar.error(
                  i18n.t(
                    "StockOrderOUT.Messages.scan_package_barcode_or_container_barcode_msg"
                  )
                );
              }
            } else if (unConfirmDetail == undefined) {
              item_detail.pack_confirm_num = item_detail.pack_confirm_num_input;
              this.unConfirmDetails.push(item_detail);
              location == 2
                ? this.confirmingDetails.splice(
                    this.confirmingDetails.findIndex(
                      (confirming_detail) =>
                        confirming_detail.material_id == item_detail.material_id
                    ),
                    1
                  )
                : location == 3
                ? this.confirmedDetails.splice(
                    this.confirmedDetails.findIndex(
                      (confirmed_detail) =>
                        confirmed_detail.material_id == item_detail.material_id
                    ),
                    1
                  )
                : "";
            } else {
              item_detail.pack_confirm_num_input = 0;
            }
          } else {
            item_detail.pack_confirm_num_input = item_detail.pack_confirm_num;
          }
        }.bind(this)
      );
    },

    cancelEditPackConfirmNum(item_detail) {
      item_detail.pack_confirm_num_input = item_detail.pack_confirm_num;
    },

    submitPackConfirm() {
      if (this.stock.pack_setting || this.stock.container_setting) {
        if (this.unConfirmDetails.length || this.confirmingDetails.length) {
          this.dialogAlert = true;
          this.dialogAlertMsg = i18n.t(
            "StockOrderOUT.Messages.submit_package_error_msg"
          );
        } else {
          var confirmedDetailsCopy = {};
          var packageDetails = [];
          var stock_order_id = 0;

          //整理数据结构，以material_id为key
          this.confirmedDetails.forEach((confirmed_detail) => {
            if (!confirmedDetailsCopy[confirmed_detail.material_id]) {
              confirmedDetailsCopy[confirmed_detail.material_id] = [
                confirmed_detail,
              ];
            } else {
              confirmedDetailsCopy[confirmed_detail.material_id].push(
                confirmed_detail
              );
            }
          });
          for (var key in confirmedDetailsCopy) {
            var packContainerRelations = [];
            for (var child_key in confirmedDetailsCopy[key]) {
              if (!stock_order_id) {
                stock_order_id =
                  confirmedDetailsCopy[key][child_key].stock_order_id;
              }

              if (this.stock.pack_setting && !this.stock.container_setting) {
                packContainerRelations.push({
                  pack_code:
                    confirmedDetailsCopy[key][child_key].package_barcode,
                  out_num:
                    confirmedDetailsCopy[key][child_key].pack_confirm_num,
                });
              } else {
                packContainerRelations.push({
                  pack_code:
                    confirmedDetailsCopy[key][child_key].package_barcode,
                  container_bar_code:
                    confirmedDetailsCopy[key][child_key].container_barcode,
                  out_num:
                    confirmedDetailsCopy[key][child_key].pack_confirm_num,
                });
              }
            }
            packageDetails.push({
              material_id: confirmedDetailsCopy[key][0].material_id,
              out_num: confirmedDetailsCopy[key][0].confirm_num,
              pack_container_relations: packContainerRelations,
            });
          }

          //提交
          StockOuts.submitPackConfirm({
            id: stock_order_id,
            stock_order_code: this.stock_order_code,
            stock_order_details: packageDetails,
          }).then(
            function (response) {
              if (response.data.status.isOK()) {
                // this.$router.replace("/stock-orders-out");
                //跳回输入出库单界面
                this.packConfirming = false;
              }
            }.bind(this)
          );
        }
      } else {
        StockOuts.submitPackConfirm({
          stock_order_code: this.stock_order_code,
        }).then(
          function (response) {
            if (response.data.status.isOK()) {
              // this.$router.replace("/stock-orders-out");
              //跳回输入出库单界面
              this.packConfirming = false;
            }
          }.bind(this)
        );
      }
    },

    addPackageBarcode() {
      var new_package_barcode = "";
      if (!this.packageBarcodes.length) {
        new_package_barcode = this.stock_order_code + "/1";
        this.packageBarcodes.push({ package_barcode: new_package_barcode });
      } else {
        var last_number = [];
        this.packageBarcodes.forEach((packageBarcode) => {
          var code = packageBarcode.package_barcode.split("/");
          last_number.push(Number(code[1]));
        });
        new_package_barcode =
          this.stock_order_code + "/" + (Math.max.apply(null, last_number) + 1);
        this.packageBarcodes.push({ package_barcode: new_package_barcode });
      }
    },
  },

  mounted() {
    //生产出库
    if (this.$route.path.startsWith("/production-stock-out")) {
      this.productionStockOUTFlg = true;
      this.orderStockOUTFlg = false;
    } else if (this.$route.path.startsWith("/order-stock-out")) {
      //要货出库
      this.productionStockOUTFlg = false;
      this.orderStockOUTFlg = true;
    } else {
      this.productionStockOUTFlg = false;
      this.orderStockOUTFlg = false;
    }
    var stock_selected_session = sessionStorage.getItem(
      "pack-confirm-stockSelected"
    );
    if (
      typeof stock_selected_session != "undefined" &&
      stock_selected_session != null &&
      stock_selected_session != "null"
    ) {
      stock_selected_session = JSON.parse(stock_selected_session);
      this.selectStock = stock_selected_session;
    } else {
      this.selectStockDialog = true;
    }
  },

  watch: {
    selectStock: {
      handler() {
        if (this.selectStock) {
          Stocks.fetchOne(this.selectStock.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.stock = response.data.stock;
              }
            }.bind(this)
          );
          sessionStorage.setItem(
            "pack-confirm-stockSelected",
            JSON.stringify(this.selectStock)
          );
          if (this.selectStockDialog) {
            this.selectStockDialog = false;
          }
          this.$nextTick(() => {
            this.$refs.stock_out_code.focus();
          });
        }
      },
    },
    stock_out_code: {
      handler() {
        clearInterval(this.monitorTime);
        if (this.stock_out_code) {
          this.monitorTime = setTimeout(
            function () {
              if (Object.keys(this.stock).length) {
                StockOuts.packConfirm({
                  stock_id: this.stock.id,
                  bar_code: this.stock_out_code,
                }).then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.packConfirming = true;
                      this.stock_order_code = response.data.stock_order_code;
                      this.stockOutDetails = response.data.details;
                      this.stockOutDetails.forEach((detail) => {
                        detail.pack_confirm_num = 0;
                        detail.pack_confirm_num_input = 0;
                        detail.material_description = i18n.t(
                          this.settings
                            ? this.settings.material_name_display_type == 4
                              ? "Material.nameWithCodeAndStandard"
                              : this.settings.material_name_display_type == 3
                              ? "Material.materialNameWithCodeAndStandard"
                              : this.settings.material_name_display_type == 2
                              ? "Material.materialNameWithCode"
                              : "Material.materialName"
                            : "Material.materialName",
                          [
                            detail.material_code,
                            detail.material_name,
                            detail.standard_name,
                          ]
                        );
                      });
                      this.unConfirmDetails = JSON.parse(
                        JSON.stringify(this.stockOutDetails)
                      );
                      if (this.stock.pack_setting) {
                        this.barcode_input_lable = i18n.t(
                          "StockOrderOUT.PackConfirmFields.scan_barcode",
                          [
                            i18n.t(
                              "StockOrderOUT.PackConfirmFields.package_barcode"
                            ),
                          ]
                        );
                      } else if (this.stock.container_setting) {
                        this.scan_barcode_info.scan_package_barcode =
                          this.stock_order_code;
                        this.barcode_input_lable = i18n.t(
                          "StockOrderOUT.PackConfirmFields.scan_barcode",
                          [i18n.t("StockOrderOUT.PackConfirmFields.container")]
                        );
                      } else {
                        this.barcode_input_lable = i18n.t(
                          "StockOrderOUT.PackConfirmFields.scan_barcode",
                          [i18n.t("StockOrderOUT.PackConfirmFields.material")]
                        );
                      }
                      this.$nextTick(() => {
                        this.$refs.barcode_input.focus();
                      });
                    }
                  }.bind(this)
                );
              } else {
                this.dialogAlert = true;
                this.dialogAlertMsg = i18n.t(
                  "StockOrderOUT.Messages.unchoose_stock"
                );
              }
              this.stock_out_code = "";
            }.bind(this),
            400
          );
        }
      },
    },
    barcode_input_value: {
      handler() {
        clearInterval(this.monitorTime);
        if (this.barcode_input_value) {
          this.monitorTime = setTimeout(
            function () {
              var isFound = false;
              if (this.stock.pack_setting && this.stock.container_setting) {
                //包装码和周转筐都开启
                if (this.packageBarcodes.length) {
                  //判断输入的是不是包装码
                  this.packageBarcodes.some((packageBarcode) => {
                    if (
                      this.barcode_input_value == packageBarcode.package_barcode
                    ) {
                      isFound = true;
                      this.scan_barcode_info.scan_package_barcode =
                        this.barcode_input_value;
                      if (!packageBarcode.container_barcode) {
                        this.scan_barcode_info.scan_container_barcode = "";
                        this.barcode_input_value = "";
                        this.barcode_input_lable = i18n.t(
                          "StockOrderOUT.PackConfirmFields.scan_barcode",
                          [i18n.t("StockOrderOUT.PackConfirmFields.container")]
                        );
                      } else {
                        this.scan_barcode_info.scan_container_barcode =
                          packageBarcode.container_barcode;
                        this.barcode_input_value = "";
                        this.barcode_input_lable = i18n.t(
                          "StockOrderOUT.PackConfirmFields.scan_barcode",
                          [""]
                        );
                      }
                    }
                  });
                  //判断是商品条码还是周转筐条码
                  if (!isFound) {
                    if (this.scan_barcode_info.scan_package_barcode) {
                      if (this.scan_barcode_info.scan_container_barcode) {
                        //扫描商品
                        this.material_bar_code = this.barcode_input_value;
                      } else {
                        //扫描周转筐
                        Containers.fetchOne({
                          stock_id: this.stock.id,
                          bar_code: this.barcode_input_value,
                        }).then(
                          function (response) {
                            if (response.data.status.isOK()) {
                              if (
                                response.data.container &&
                                !response.data.container.status
                              ) {
                                this.scan_barcode_info.scan_container_barcode =
                                  this.barcode_input_value;
                                this.packageBarcodes.some((packageBarcode) => {
                                  if (
                                    packageBarcode.package_barcode ==
                                    this.scan_barcode_info.scan_package_barcode
                                  ) {
                                    packageBarcode.container_barcode =
                                      this.barcode_input_value;
                                  }
                                });
                                this.barcode_input_value = "";
                                this.barcode_input_lable = i18n.t(
                                  "StockOrderOUT.PackConfirmFields.scan_barcode",
                                  [""]
                                );
                              } else {
                                this.barcode_input_value = "";
                                snackbar.error(
                                  i18n.t(
                                    "StockOrderOUT.Messages.unusable_container_msg"
                                  )
                                );
                              }
                            } else {
                              this.barcode_input_value = "";
                            }
                          }.bind(this)
                        );
                      }
                    } else {
                      this.barcode_input_value = "";
                      snackbar.error(
                        i18n.t("StockOrderOUT.Messages.no_package_barcode_msg")
                      );
                    }
                  }
                } else {
                  //提示先去生成包装码
                  this.barcode_input_value = "";
                  this.dialogAlert = true;
                  this.dialogAlertMsg = i18n.t(
                    "StockOrderOUT.Messages.build_package_barcode_msg"
                  );
                }
              } else if (this.stock.pack_setting) {
                //只开启包装码
                if (this.packageBarcodes.length) {
                  //判断输入的是不是包装码
                  this.packageBarcodes.some((packageBarcode) => {
                    if (
                      this.barcode_input_value == packageBarcode.package_barcode
                    ) {
                      isFound = true;
                      this.scan_barcode_info.scan_package_barcode =
                        this.barcode_input_value;
                      this.barcode_input_value = "";
                      this.barcode_input_lable = i18n.t(
                        "StockOrderOUT.PackConfirmFields.scan_barcode",
                        [""]
                      );
                    }
                  });
                  //扫描商品
                  if (!isFound) {
                    if (this.scan_barcode_info.scan_package_barcode) {
                      //扫描商品
                      this.material_bar_code = this.barcode_input_value;
                    } else {
                      this.barcode_input_value = "";
                      snackbar.error(
                        i18n.t("StockOrderOUT.Messages.no_package_barcode_msg")
                      );
                    }
                  }
                } else {
                  //提示先去生成包装码
                  this.barcode_input_value = "";
                  this.dialogAlert = true;
                  this.dialogAlertMsg = i18n.t(
                    "StockOrderOUT.Messages.build_package_barcode_msg"
                  );
                }
              } else if (this.stock.container_setting) {
                //扫描周转筐
                Containers.fetchOne(
                  {
                    stock_id: this.stock.id,
                    bar_code: this.barcode_input_value,
                  },
                  false,
                  true
                ).then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      if (
                        response.data.container &&
                        !response.data.container.status
                      ) {
                        if (!this.scan_barcode_info.scan_container_barcode) {
                          this.scan_barcode_info.scan_container_barcode =
                            this.barcode_input_value;
                          this.barcode_input_value = "";
                          this.barcode_input_lable = i18n.t(
                            "StockOrderOUT.PackConfirmFields.scan_barcode",
                            [""]
                          );
                        } else {
                          this.barcode_input_value = "";
                          snackbar.error(
                            i18n.t(
                              "StockOrderOUT.Messages.scan_barcode_error_msg",
                              [
                                i18n.t(
                                  "StockOrderOUT.PackConfirmFields.material"
                                ),
                              ]
                            )
                          );
                        }
                      } else {
                        this.barcode_input_value = "";
                        snackbar.error(
                          i18n.t(
                            "StockOrderOUT.Messages.unusable_container_msg"
                          )
                        );
                      }
                    } else {
                      if (this.scan_barcode_info.scan_container_barcode) {
                        this.material_bar_code = this.barcode_input_value;
                      } else {
                        this.barcode_input_value = "";
                        snackbar.error(
                          i18n.t(
                            "StockOrderOUT.Messages.unusable_container_msg"
                          )
                        );
                      }
                    }
                  }.bind(this)
                );
              } else {
                this.material_bar_code = this.barcode_input_value;
              }
            }.bind(this),
            400
          );
        }
      },
    },
    material_bar_code: {
      handler() {
        //去除字符串两头的空格
        this.material_bar_code = this.material_bar_code.replace(
          /^\s+|\s+$/g,
          ""
        );
        if (this.material_bar_code) {
          //当前扫描商品在未确认中
          var unConfirmDetail = this.unConfirmDetails.find(
            (detail) => detail.material_bar_code == this.material_bar_code
          );
          //当前扫描商品在确认中列表中
          var confirmingLists = this.confirmingDetails.filter(
            (confirming_detail) =>
              confirming_detail.material_bar_code == this.material_bar_code
          );
          //当前扫描商品在已确认列表中
          var confirmedDetail = this.confirmedDetails.find(
            (confirmed_detail) =>
              confirmed_detail.material_bar_code == this.material_bar_code
          );

          if (unConfirmDetail != undefined) {
            ++unConfirmDetail.pack_confirm_num;
            unConfirmDetail.package_barcode =
              this.scan_barcode_info.scan_package_barcode;
            //是否开启了周转筐设置
            if (this.stock.container_setting) {
              unConfirmDetail.container_barcode =
                this.scan_barcode_info.scan_container_barcode;
            }

            //判断当前扫描的商品是部分确认还是全部确认
            unConfirmDetail.pack_confirm_num_input =
              unConfirmDetail.pack_confirm_num;
            unConfirmDetail.pack_confirm_num == unConfirmDetail.confirm_num
              ? this.confirmedDetails.push(unConfirmDetail)
              : this.confirmingDetails.push(unConfirmDetail);

            this.unConfirmDetails.splice(
              this.unConfirmDetails.findIndex(
                (stock_out_detail) =>
                  stock_out_detail.material_bar_code == this.material_bar_code
              ),
              1
            );
          } else if (confirmingLists.length) {
            var existDetail = [];
            var editDetail = [];
            var pack_confirm_num_count = 0;
            var isAdd = false; //是否装入新的包装码中

            if (
              //开启了包装码和周转筐设置
              this.stock.pack_setting &&
              this.stock.container_setting
            ) {
              existDetail = confirmingLists.find(
                (list) =>
                  list.package_barcode ==
                  this.scan_barcode_info.scan_package_barcode
              );
              if (existDetail) {
                isAdd = false;
                editDetail = JSON.parse(JSON.stringify(existDetail)); //避免修改原数据
              } else {
                isAdd = true;
                if (confirmingLists)
                  editDetail = JSON.parse(JSON.stringify(confirmingLists[0])); //避免修改原数据
              }
            } else {
              editDetail = JSON.parse(JSON.stringify(confirmingLists[0])); //避免修改原数据
            }

            if (editDetail) {
              if (isAdd) {
                editDetail.package_barcode =
                  this.scan_barcode_info.scan_package_barcode;
                //判断当前扫描的包装码是否绑定了周转筐
                if (this.scan_barcode_info.scan_container_barcode) {
                  editDetail.container_barcode =
                    this.scan_barcode_info.scan_container_barcode;
                }
                editDetail.pack_confirm_num = 1;
                this.confirmingDetails.push(editDetail);
                this.confirmingDetails.forEach((confirming_detail) => {
                  if (confirming_detail.material_id == editDetail.material_id) {
                    pack_confirm_num_count =
                      pack_confirm_num_count +
                      confirming_detail.pack_confirm_num;
                  }
                });
              } else {
                this.confirmingDetails.forEach((confirming_detail) => {
                  if (
                    //开启了包装码和周转筐设置
                    this.stock.pack_setting &&
                    this.stock.container_setting
                  ) {
                    if (
                      confirming_detail.material_id == editDetail.material_id &&
                      confirming_detail.package_barcode ==
                        this.scan_barcode_info.scan_package_barcode
                    ) {
                      ++confirming_detail.pack_confirm_num;
                    }
                  } else if (
                    //开启了周转筐设置
                    !this.stock.pack_setting &&
                    this.stock.container_setting
                  ) {
                    if (
                      confirming_detail.material_id == editDetail.material_id &&
                      confirming_detail.container_barcode ==
                        this.scan_barcode_info.scan_container_barcode
                    ) {
                      ++confirming_detail.pack_confirm_num;
                    }
                  } else {
                    if (
                      confirming_detail.material_id == editDetail.material_id
                    ) {
                      ++confirming_detail.pack_confirm_num;
                    }
                  }
                });
              }
              //判断当前商品是否已拣完
              this.confirmingDetails.forEach((detail) => {
                if (detail.material_id == editDetail.material_id) {
                  pack_confirm_num_count += detail.pack_confirm_num;
                }
              });

              if (pack_confirm_num_count == editDetail.confirm_num) {
                confirmingLists.forEach((details) => {
                  this.confirmedDetails.push(details);
                  this.confirmingDetails.splice(
                    this.confirmingDetails.findIndex(
                      (confirming_detail) =>
                        confirming_detail.material_bar_code ==
                        this.material_bar_code
                    ),
                    1
                  );
                });
              }
            }
          } else if (confirmedDetail != undefined) {
            this.dialogAlert = true;
            this.dialogAlertMsg = i18n.t(
              "StockOrderOUT.Messages.greater_than_confirm_num"
            );
          }
          this.barcode_input_value = "";
          this.material_bar_code = "";
        }
      },
    },
    confirmedDetails: {
      handler() {
        if (
          this.confirmedDetails.length &&
          this.unConfirmDetails.length == 0 &&
          this.confirmingDetails == 0
        ) {
          this.submitPackConfirm();
        }
      },
    },
  },

  beforeDestroy() {
    clearInterval(this.monitorTime);
  },
};
</script>